import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={6}
    height={10}
    fill="currentColor"
    viewBox="0 0 6 10"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.5 5 .25 1.75a.79.79 0 0 1-.23-.583.79.79 0 0 1 .23-.584.79.79 0 0 1 .583-.229.79.79 0 0 1 .584.23L5.25 4.416a.731.731 0 0 1 .177.27A.922.922 0 0 1 5.48 5a.922.922 0 0 1-.052.313.731.731 0 0 1-.177.27L1.417 9.417a.79.79 0 0 1-.584.229.79.79 0 0 1-.583-.23.79.79 0 0 1-.23-.583.79.79 0 0 1 .23-.583z"
    />
  </svg>
);
export default SvgChevronRight;
